
































































































































































































































































































































/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import FormTextInput from '@/components/shared/FormTextInput.vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';
import ColorPalette from '@/models/ColorPalette';
import LayerIndicators from '@/models/map-context/LayerIndicators';
import ColorPalettePanel from '@/components/shared/ColorPalettePanel.vue';
import Indicator, { IndicatorAggregationType } from '@/models/map-context/Indicator';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import FormNumberInput from '@/components/shared/FormNumberInput.vue';
import FormComboInput from '@/components/shared/FormComboInput.vue';
import FormHtmlEditor from '@/components/shared/FormHtmlEditor.vue';

@Component({
  props: {
    layer: LayerConfig,
  },
  components: {
    FormTextInput,
    ColorPalettePanel,
    FormHtmlEditor,
    FormNumberInput,
    FormComboInput,
  },
})
export default class IndicatorInfos extends BaseComponent {
  layer!: LayerConfig;

  newIndic = false;

  attribute: LayerAttribute | null = null;

  attributelabel: LayerAttribute | null = null;

  valueAttribute: LayerAttribute | null = null;

  aggregationType: IndicatorAggregationType = 'count';

  showCenterObjetDatas=false;

  useColorFromAnalyse=false;

  nbColors = 10;

  label = '';

  colorPalette: ColorPalette | null = null;

  colorPalettes: ColorPalette[] = [];

  indicators = new LayerIndicators();

  textContent = '';

  textSelectContent = '';

  graphType = '';

  graphTypes = [
    { text: 'Zone de texte ', value: 'textarea' },
    { text: 'Bar chart affichant les valeurs min/max et moyenne', value: 'minmaxmean' },
    { text: 'Donut chart par valeurs distinctes (count / somme / moyenne)', value: 'distinct_donut' },
  ];

  aggregationTypes = [
    { text: 'Nombre d\'objets (count)', value: 'count' },
    { text: 'Somme', value: 'sum' },
    { text: 'Moyenne', value: 'mean' },
  ];

  mounted() {
    this.colorPalettes = this.contextService.colorPalettes;
    console.log(this.colorPalettes);
    if (this.layer.indicators) {
      this.indicators = this.layer.indicators;
    }
  }
  changeAttributeLabel(indic: Indicator, attribute: LayerAttribute) {
    console.log(attribute);
    indic.labelAttribute = attribute.name;
  }
  changeValueAttribute(indic: Indicator, attribute: LayerAttribute) {
    indic.valueAttribute = attribute ? attribute.name : undefined;
  }
  getAggregationLabel(type?: IndicatorAggregationType) {
    const found = this.aggregationTypes.find((item) => item.value === (type || 'count'));
    return found ? found.text : 'Nombre d\'objets (count)';
  }
  onColorChange(indic:Indicator,value:any){
    indic.colorPalette = value.name;
  }
  addIndicator() {
    let indic = new Indicator();
    const needsValueAttribute = this.graphType == 'distinct_donut' && this.aggregationType != 'count';
    if (this.attribute && this.attributelabel && (!needsValueAttribute || this.valueAttribute)) {
      indic.attributeName = this.attribute.name;
      indic.labelAttribute = this.attributelabel.name;
      indic.label = this.label;
      indic.graphType = this.graphType;
      indic.showCenterObject=this.showCenterObjetDatas;
      indic.useColorFromAnalyse=this.useColorFromAnalyse;
      if (this.graphType == 'distinct_donut') {
        indic.aggregationType = this.aggregationType;
        indic.valueAttribute = needsValueAttribute && this.valueAttribute
          ? this.valueAttribute.name
          : undefined;
      }
      if (this.graphType == 'textarea') {
        indic.textContent = this.textContent;
        indic.textSelectContent = this.textSelectContent;
      } else if (this.colorPalette) {
        indic.colorPalette = this.colorPalette.name;
        indic.nbColors=this.nbColors;
      }
    }

    this.layer.indicators.indicators.push(indic);
    this.newIndic = false;
  }

  getColorPalette(x: any) {
    return new ColorPalette(x);
  }

  removeIndic(rule: Indicator) {
    const ruleIndex = this.layer.indicators.indicators.indexOf(rule);
    this.layer.indicators.indicators.splice(ruleIndex, 1);
  }
   moveUp(rule: Indicator) {
    const ruleIndex = this.layer.indicators.indicators.indexOf(rule);
    if (ruleIndex > 0) {
      this.layer.indicators.indicators.splice(ruleIndex, 1);
      this.layer.indicators.indicators.splice(ruleIndex - 1, 0, rule);
    }
  }
   moveDown(rule: Indicator) {
    const ruleIndex = this.layer.indicators.indicators.indexOf(rule);
    if (ruleIndex < this.layer.indicators.indicators.length - 1) {
      this.layer.indicators.indicators.splice(ruleIndex, 1);
      this.layer.indicators.indicators.splice(ruleIndex + 1, 0, rule);
    }
  }

}
